import { SVGProps } from "react";

export default function LogoutIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#AE372A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.5859 6.3002C12.3276 3.3002 10.7859 2.0752 7.41094 2.0752H7.3026C3.5776 2.0752 2.08594 3.56686 2.08594 7.29186V12.7252C2.08594 16.4502 3.5776 17.9419 7.3026 17.9419H7.41094C10.7609 17.9419 12.3026 16.7335 12.5776 13.7835"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M7.50104 10H16.9844"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1224 7.20862L17.9141 10.0003L15.1224 12.792"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}